import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CareTypeService {

  constructor(
    private baseService: BaseService,
    private Aroute: ActivatedRoute
  ) { }

  getCareTypeConfig() {
    // return new Promise((resolve)=>{
      console.log("route is :: ",this.Aroute.snapshot.queryParams)
      console.log("this.baseService._resourceName",this.baseService._resourceName)
      this.baseService.getResourceDef(this.baseService._resourceName, (resource) => {
        if (resource) {
          resource.config.care_type == undefined ? false : resource.config.care_type
        }
      })
    // })
  }
}
